/**
 * List search comes only from URL `search` and the debounced search box.
 * Selection `orderId` must never be treated as a search term — that collapsed the list to one row on click.
 */
export function effective_list_search(
  url_search: string,
  debounced_search: string
): string | undefined {
  const from_url = (url_search ?? '').trim();
  if (from_url) return from_url;
  const from_state = (debounced_search ?? '').trim();
  if (from_state) return from_state;
  return undefined;
}

/**
 * True when the selected order is already on the loaded page.
 * Used to skip deep-link locate on in-list clicks, including page 1 where `page` is omitted from the URL.
 */
export function order_is_on_loaded_page(
  orders: Array<{ production_order_id: number }>,
  selected_id: number | null
): boolean {
  if (selected_id == null) return false;
  return orders.some((order) => order.production_order_id === selected_id);
}

/**
 * Deep-link locate (`search=<id>`) only when the selected id is not already in the loaded list.
 * Empty list (first paint) and off-page ids should locate; on-page selection must not.
 */
export function should_locate_selected_order(
  orders: Array<{ production_order_id: number }>,
  selected_id: number | null
): boolean {
  if (selected_id == null) return false;
  return !order_is_on_loaded_page(orders, selected_id);
}
